import { Button } from "antd"
import { getAgreementInfo } from "api/mall"
import { PwdEntryInterface } from "comps/AuthSubjectBoundry"
import MallField from "comps/MallField"
import { useEffect, useRef, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { Icon } from "react-vant"

export function AgreementPwdEntry({
  error,
  submitForm,
  id,
}: PwdEntryInterface) {
  const [info, setInfo] = useState({
    agreementName: "",
    inUserName: "",
    inUserPhone: "",
  })
  const [errInfo, setErrInfo] = useState("")
  const formData = useRef({ password: "" }).current

  useEffect(() => {
    getAgreementInfo(id).then((res) => {
      if (res.data) {
        setInfo(res.data)
      }
    })
  }, [id])

  useEffect(() => {
    if (error?.message) {
      setErrInfo(error.message)
    }
  }, [error])

  const {
    handleSubmit,
    control,
    formState: { errors: formErr },
  } = useForm()

  const onSubmit = ({ formData }) => {
    if (!formData.password) {
      setErrInfo("密码不能为空")
      return
    }
    submitForm(formData.password)
  }

  return (
    <>
      <div className="pwd-container">
        <div className="agreement-name">《{info.agreementName}》</div>
        <div className="entry">
          <Controller
            name="formData.password"
            control={control}
            defaultValue={formData?.password}
            rules={{}}
            render={({ field }: any) => (
              <>
                <MallField
                  {...field}
                  border
                  type="password"
                  inputAlign="left"
                  errorMessageAlign="left"
                  label=""
                  placeholder="请输入访问密码"
                  maxlength="6"
                  errorMessage={""}
                  leftIcon={<Icon name="lock" color="#999" />}
                  onChange={(v) => {
                    setErrInfo("")
                    field.onChange(v)
                  }}
                />
              </>
            )}
          />
          <div className="err">{errInfo}</div>

          <Button onClick={handleSubmit(onSubmit)} type="primary" size="large">
            确定
          </Button>
        </div>
        <div className="info">
          <Icon name="info-o" />
          如需帮助，请联系规则创建人{info.inUserName}（{info.inUserPhone}）
        </div>
      </div>
      <style jsx>{`
        .pwd-container {
          display: flex;
          height: 100%;
          flex-direction: column;
          overflow: hidden;
          padding-top: 150px;
          align-items: center;
          background: #fff;
        }
        .agreement-name {
          margin-bottom: 35px;
          font-size: 18px;
          color: #333333;
          font-weight: bolder;
        }
        .entry {
          width: 280px;
        }
        .entry :global(button) {
          width: 100%;
          margin-top: 20px;
        }
        .entry :global(button[disabled]) {
          background: #1156ff;
          border-radius: 3px;
          opacity: 0.3;
          ont-size: 16px;
          color: #ffffff;
        }
        .entry :global(.rv-cell) {
          height: 42px;
          padding-top: 9px;
          padding-bottom: 9px;
          background: #fff;
          border: 1px solid #d6d6d6;
          border-radius: 3px;
        }
        .err {
          color: #f00;
          margin-top: 5px;
        }
        .info {
          margin-top: 25px;
          width: 280px;
          font-size: 14px;
          color: #999999;
          text-align: center;
        }
        .info :global(i) {
          margin-right: 6px;
        }
      `}</style>
    </>
  )
}
